import { footerQuick } from "@/mocks/chigua";

export default function Footer() {
  return (
    <footer className="bg-background-200/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.3fr_1fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-bard-fill text-lg"></i>
              </span>
              <span className="font-display text-xl text-foreground-950">吃瓜福利</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              吃瓜福利是一个集中整理今日更新、每日推荐、最新发布与实时更新的内容入口站，
              用更轻的方式帮你跟上每天的热点节奏，别错过想看的瓜。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-record-circle-fill text-primary-500 animate-pulse"></i>
                更新状态正常
              </span>
              <span className="rounded-full bg-background-50 border border-background-200 px-2 py-0.5 whitespace-nowrap">
                今日已更新 186 篇
              </span>
            </div>
          </div>

          {footerQuick.map((col) => (
            <div key={col.title}>
              <h3 className="text-sm font-bold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a href="#top" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 吃瓜福利 · 内容入口站，仅作资讯聚合与页面演示用途。
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <a href="#top" className="hover:text-primary-600">站点地图</a>
            <a href="#top" className="hover:text-primary-600">更新说明</a>
            <a href="#top" className="hover:text-primary-600">内容收录</a>
            <a href="#top" className="hover:text-primary-600">合作联系</a>
          </div>
        </div>
      </div>
    </footer>
  );
}